/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PracticeBranchInfoDto } from './PracticeBranchInfoDto';
import {
    PracticeBranchInfoDtoFromJSON,
    PracticeBranchInfoDtoFromJSONTyped,
    PracticeBranchInfoDtoToJSON,
    PracticeBranchInfoDtoToJSONTyped,
} from './PracticeBranchInfoDto';

/**
 * 
 * @export
 * @interface DataSharingRequestDto
 */
export interface DataSharingRequestDto {
    /**
     * Request ID
     * @type {string}
     * @memberof DataSharingRequestDto
     */
    id: string;
    /**
     * Practice ID
     * @type {string}
     * @memberof DataSharingRequestDto
     */
    practiceId: string;
    /**
     * Practice name
     * @type {string}
     * @memberof DataSharingRequestDto
     */
    practiceName: string;
    /**
     * Request status
     * @type {string}
     * @memberof DataSharingRequestDto
     */
    status: DataSharingRequestDtoStatusEnum;
    /**
     * Request date
     * @type {string}
     * @memberof DataSharingRequestDto
     */
    requestedAt: string;
    /**
     * Approval date (only for live status)
     * @type {string}
     * @memberof DataSharingRequestDto
     */
    approvedAt?: string;
    /**
     * Revocation date (only for revoked status)
     * @type {string}
     * @memberof DataSharingRequestDto
     */
    revokedAt?: string;
    /**
     * Practice branches
     * @type {Array<PracticeBranchInfoDto>}
     * @memberof DataSharingRequestDto
     */
    branches: Array<PracticeBranchInfoDto>;
}


/**
 * @export
 */
export const DataSharingRequestDtoStatusEnum = {
    Requesting: 'requesting',
    ActiveSharing: 'active_sharing',
    Revoked: 'revoked'
} as const;
export type DataSharingRequestDtoStatusEnum = typeof DataSharingRequestDtoStatusEnum[keyof typeof DataSharingRequestDtoStatusEnum];


/**
 * Check if a given object implements the DataSharingRequestDto interface.
 */
export function instanceOfDataSharingRequestDto(value: object): value is DataSharingRequestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('practiceId' in value) || value['practiceId'] === undefined) return false;
    if (!('practiceName' in value) || value['practiceName'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('requestedAt' in value) || value['requestedAt'] === undefined) return false;
    if (!('branches' in value) || value['branches'] === undefined) return false;
    return true;
}

export function DataSharingRequestDtoFromJSON(json: any): DataSharingRequestDto {
    return DataSharingRequestDtoFromJSONTyped(json, false);
}

export function DataSharingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSharingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'practiceId': json['practiceId'],
        'practiceName': json['practiceName'],
        'status': json['status'],
        'requestedAt': json['requestedAt'],
        'approvedAt': json['approvedAt'] == null ? undefined : json['approvedAt'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'branches': ((json['branches'] as Array<any>).map(PracticeBranchInfoDtoFromJSON)),
    };
}

export function DataSharingRequestDtoToJSON(json: any): DataSharingRequestDto {
    return DataSharingRequestDtoToJSONTyped(json, false);
}

export function DataSharingRequestDtoToJSONTyped(value?: DataSharingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'practiceId': value['practiceId'],
        'practiceName': value['practiceName'],
        'status': value['status'],
        'requestedAt': value['requestedAt'],
        'approvedAt': value['approvedAt'],
        'revokedAt': value['revokedAt'],
        'branches': ((value['branches'] as Array<any>).map(PracticeBranchInfoDtoToJSON)),
    };
}

